import { render } from "./EventBroadcastHelp.vue?vue&type=template&id=1e3bc1ec"
import script from "./EventBroadcastHelp.vue?vue&type=script&lang=js"
export * from "./EventBroadcastHelp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__